import { render, staticRenderFns } from "./ProductTileWidget.vue?vue&type=template&id=62e46130&scoped=true&lang=pug&"
import script from "./ProductTileWidget.vue?vue&type=script&lang=js&"
export * from "./ProductTileWidget.vue?vue&type=script&lang=js&"
import style0 from "./ProductTileWidget.vue?vue&type=style&index=0&id=62e46130&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62e46130",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jackie/sites/cardinalco/ylang-23/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('62e46130')) {
      api.createRecord('62e46130', component.options)
    } else {
      api.reload('62e46130', component.options)
    }
    module.hot.accept("./ProductTileWidget.vue?vue&type=template&id=62e46130&scoped=true&lang=pug&", function () {
      api.rerender('62e46130', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/product/ProductTileWidget.vue"
export default component.exports